export default "/images/vendor/flag-icons/flags/1x1/cz.svg?f7d5fa0258940e2c3ac9bb2c2ec57633";